/* ============================================================
 * 23TM accordion single-open behavior (regola 23 v4.2.7 LOCKED 2026-05-21)
 * ============================================================
 * Capo direttiva: quando apri un accordion sul product page, gli altri
 * si chiudono automatic (mutually exclusive). Scope: 4 accordion del
 * product page (Features / Care Instructions / Fabric / EU-GPSR), via
 * generic selector .product__accordion details (vale anche per future
 * accordion aggiunti).
 * ============================================================ */
(function() {
  function initSingleOpenAccordion() {
    const accordions = document.querySelectorAll('.product__accordion details');
    if (accordions.length === 0) return;
    accordions.forEach(function(detail) {
      detail.addEventListener('toggle', function() {
        if (this.open) {
          accordions.forEach(function(other) {
            if (other !== detail && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSingleOpenAccordion);
  } else {
    initSingleOpenAccordion();
  }
})();
